import { DEV_TEST_EMAIL } from "./devAuth";

export const STAFF_ROLES = ["superadmin", "moderator", "support"];

export function getUserRole(userProfile) {
  if (userProfile?.role) return userProfile.role;
  if (userProfile?.isCreator) return "creator";
  return "fan";
}

export function isSuperAdmin(userProfile) {
  return userProfile?.role === "superadmin";
}

export function hasStaffContentAccess(userProfile) {
  return STAFF_ROLES.includes(getUserRole(userProfile));
}

export function hasCreatorAccess(userProfile) {
  return Boolean(userProfile?.isCreator) || isSuperAdmin(userProfile);
}

export function bypassesEmailVerification(userProfile, currentUser = null) {
  if (isSuperAdmin(userProfile)) return true;
  if (currentUser?.email?.toLowerCase() === DEV_TEST_EMAIL.toLowerCase()) return true;
  return false;
}

export function bypassesContentPaywall(userProfile) {
  return hasStaffContentAccess(userProfile);
}
